const invertedMessages = {
  'Risk Insights': 'external.dashboard.riskInsights',
  Review: 'external.dashboard.review',
  'No Risk Insights Available': 'external.dashboard.noRiskInsights',
  'View More Insights': 'external.dashboard.viewMore',
  'View less': 'external.dashboard.viewLess',
};

export default invertedMessages;
